var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirtual = function SvgVirtual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.694 50.975V5.428a4.76 4.76 0 0 1 4.76-4.761H71.38a4.76 4.76 0 0 1 4.759 4.761v45.547l-35.222-.44-35.223.44Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.39 7.188-.001 40.307H70.71V7.188a.827.827 0 0 0-.827-.827H12.216a.827.827 0 0 0-.827.827Z",
    fill: "#E9EBF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.468 56.285h75.064c3.468 0 3.455-3.03 3.467-4.935a.826.826 0 0 0-.826-.816H49.439a.827.827 0 0 0-.826.827v.127c0 .923-.749 1.672-1.672 1.672H31.738a1.672 1.672 0 0 1-1.672-1.672v-.127a.827.827 0 0 0-.826-.827H.826a.826.826 0 0 0-.825.816c.011 1.906-.001 4.935 3.467 4.935Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M78.532 54.797H3.468A3.468 3.468 0 0 1 0 51.33v2.976a3.468 3.468 0 0 0 3.468 3.467h75.064A3.468 3.468 0 0 0 82 54.305V51.33a3.468 3.468 0 0 1-3.468 3.468Z",
    fill: "#CAD1DE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 26.861,
    r: 12.528,
    fill: "#A1ACC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m39.609 23.144 4.855 2.803a1.072 1.072 0 0 1 0 1.858l-4.855 2.803A1.072 1.072 0 0 1 38 29.679v-5.606a1.072 1.072 0 0 1 1.609-.93Z",
    fill: "#fff"
  })));
};
export default SvgVirtual;